(function ($)
{
    $.widget("ui.StoryBlock",
    {
        options:
        {
            PageContentId: null,
            NavigationUrl: "/Core/Stories/Block/",
            LoadingHTML: '<div>'
                + '<span class="loading_icon" title="Loading..."><i class="fa-solid fa-sync fa-spin"></i></span>'
                + '<div class="message_text">Loading...</div>'
                + '</div>',
            ErrorHTML: '<div>'
                + '<img class="error_image" src="/img/ajax_error.gif" alt="Error Loading Story Block." title="Error Loading Story Block."/>'
                + '<div class="message_text">Error Loading Story Block.</div>'
                + '</div>',
            LoadingClass: 'story_loading',
            OverlayClass: 'story_overlay',
            OverlayLoadingClass: 'overlay_loading',
            OverlayErrorClass: 'overlay_error',
            StoryClickSelector: '.story_title,.story_thumbnail,.story_largeimage'
        },

        ContentId: null,
        
        _destroy: function ()
        {
        },

        _init: function ()
        {           
            VideoUtilities.SetupVideoResizer('.storymedia_video');
        },

        _create: function ()
        {
            var self = this;
            var jElement = $(self.element);
            
            self.ContentId = self.options.PageContentId;
            
            jElement.on(
                'click',
                self.options.StoryClickSelector,
                function(aEvent)
                {
                    aEvent.preventDefault();
                    let lMenuItem = $(aEvent.target).parents('.story');
                    if (lMenuItem.length == 1)
                    {
                        let lStoryTitleLink = lMenuItem.find('.story_title[data-href]');
                        if (lStoryTitleLink.length == 1)
                        {
                            let lNewPageUrl = lStoryTitleLink.data('href');
                            let isTargetNew = lStoryTitleLink.data('target-new');
                            if (!FBUtilities.IsStringEmptyOrWhitespace(lNewPageUrl))
                            {
                                if (isTargetNew)
                                {
                                    window.open(lNewPageUrl, "_blank");
                                }
                                else
                                {
                                    window.location.href = lNewPageUrl;
                                }
                            }
                        }
                    }
                    return false;
                }
            );

            self._InitClickSelectorElements();

            FBUrlManager.setParameterDefault('StoryId', self.GetStoryId());
        },
        
        _InitClickSelectorElements: function()
        {
            $(this.element)
                .find(this.options.StoryClickSelector)
                .filter(function (_index)
                {
                    const lMenuItem = $(this).parents('.story');
                    if (lMenuItem.length === 0)
                    {
                        // no story.
                        return false;
                    }

                    const lStoryTitleLink = lMenuItem.find('.story_title[data-href]');
                    if (lStoryTitleLink.length === 0)
                    {
                        // no title
                        return false;
                    }

                    const lNewPageUrl = lStoryTitleLink.data('href');
                    if (FBUtilities.IsStringEmptyOrWhitespace(lNewPageUrl))
                    {
                        // no link
                        return false;
                    }

                    // have link
                    return true;
                })
                .css('cursor', 'pointer')
                .attr('tabindex', '0');
        },
        
        _UseStoryRedirect: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            if (!FBUtilities.IsStringEmptyOrWhitespace(self.options.StoryClickSelector)
                && !FBUtilities.IsStringEmptyOrWhitespace(self.options.StoryRedirectUrl))
            {
                return true;
            }
            return false;
        },
        
        GetStoryId: function ()
        {
            var self = this;
            var jElement = $(self.element);
            
            var lCurrentStory = jElement.find('.story');
            
            if (lCurrentStory.length != 1)
            {
                return null;
            }
            
            return lCurrentStory.data('story-id');
        },
        
        LoadStory: function (aStoryId, aCallbacks, aTransitionSpeed)
        {
            var self = this;
            var jElement = $(self.element);
            
            if (FBUtilities.IsParameterUndefinedOrEmpty(aStoryId))
            {
                return;
            }
            
            var lCurrentStory = jElement.find('.story');
            
            //ok, do we nuke the current content even if we find nothing?
            self.DisplayLoadingOverlay();

            $.ajax(self.options.NavigationUrl + self.ContentId + '?StoryId=' + aStoryId, 
            {
                success: function (aData, aTextStatus, aJqXHR)
                {
                    // Reset story media rotators.
                    $.each(
                        jElement.find('.storymedia'),
                        function (_index, aValue)
                        {
                            let identifier = $(aValue).attr('id');
                            let element = $(`#${identifier}`);
                            if (element.RotatorManager('instance') !== undefined)
                            {
                                element.RotatorManager('destroy');
                            }
                        }
                    );

                    // Reset photo gallery rotators.
                    $.each(
                        jElement.find('.fbcms_photogallery .fbcms_imagerotator'),
                        function (_index, aValue)
                        {
                            let identifier = $(aValue).parent('.fbcms_photogallery').attr('id');
                            let element = $(`#${identifier}`);
                            if (element.RotatorManager('instance') !== undefined)
                            {
                                element.RotatorManager('destroy');
                            }
                        }
                    );

                    self.AnimateNewData(
                        lCurrentStory,
                        aData,
                        function()
                        {
                            self._InitClickSelectorElements();
                            self.ClearOverlay();

                            $.each(
                                jElement.find('.storymedia'),
                                function (_index, aValue)
                                {
                                    let identifier = $(aValue).attr('id');
                                    let element = $(`#${identifier}`);
                                    element.RotatorManager();
                                }
                            );

                            // Initialize galleries in block.
                            $.each(
                                jElement.find('.fbcms_photogallery .fbcms_imagerotator'),
                                function (_index, aValue)
                                {
                                    let identifier = $(aValue).parent('.fbcms_photogallery').attr('id');
                                    let element = $(`#${identifier}`);
                                    element.RotatorManager();
                                }
                            );

                            console.log(`Story Ajax loadup!`);
                            FBUtilities.initializeLoadables(jElement.get(0));
                            
                            FBUtilities.RunCallback(aCallbacks, 'OnSuccess', self.GetStoryId());
                            jElement.find( '.vp_share_panel' ).ShareLink( {} );
                        },
                        aTransitionSpeed
                    );

                    // update the address bar to have the url that would lead to the currently displayed story.
                    FBUrlManager.updateAddressBar('StoryId', aStoryId);
                },
                error: function (aJqXHR, aTextStatus, aErrorThrown)
                {
                    self.DisplayErrorOverlay();
                },
                complete: function (aJqXHR, aTextStatus, aErrorThrown)
                {
                    FBUtilities.RunCallback(aCallbacks, 'OnComplete');
                },
                type: 'POST'
            });
        },
        
        AnimateNewData: function(aCurrentElement, aNewData, aOnComplete, aTransitionSpeed)
        {
            var self = this;
            var jElement = $(self.element);
        
            var lTransitionSpeed = parseInt(aTransitionSpeed);
            var lFadeOutSpeed = 0;
            var lFadeInSpeed = 0;
            if (!isNaN(lTransitionSpeed)
                && lTransitionSpeed > 0)
            {
                lFadeOutSpeed = (lTransitionSpeed/2);
                lFadeInSpeed = (lTransitionSpeed/2);
            }
            
            aCurrentElement.fadeOut(
                lFadeOutSpeed, 
                function()
                {
                    var lData = $($.parseHTML(aNewData.toString().trim()));
                    lData.hide();
                    $(this).replaceWith(lData);
                    lData.fadeIn(
                        lFadeInSpeed,
                        aOnComplete
                    );
                }
            );
        },
        
        DisplayLoadingOverlay: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            if (jElement.hasClass(self.options.LoadingClass))
            {
                return;
            }
            jElement.addClass(self.options.LoadingClass);
            var lLoadingHtml = $('<div></div>');
            lLoadingHtml.addClass(self.options.OverlayClass);
            lLoadingHtml.addClass(self.options.OverlayLoadingClass);
            lLoadingHtml.html(self.options.LoadingHTML);
            jElement.append(lLoadingHtml);
        },
        
        DisplayErrorOverlay: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            if (!jElement.hasClass(self.options.LoadingClass))
            {
                jElement.addClass(self.options.LoadingClass);
            }
            
            var lErrorHtml = $('<div></div>');
            lErrorHtml.addClass(self.options.OverlayClass);
            lErrorHtml.addClass(self.options.OverlayErrorClass);
            lErrorHtml.html(self.options.ErrorHTML);
            
            var lOverlay = jElement.find('.' + self.options.OverlayClass);
            if (lOverlay.length != 0)
            {
                lOverlay.replaceWith( lErrorHtml );
            }
            else
            {
                jElement.append(lErrorHtml);
            }
        },
        
        ClearOverlay: function()
        {
            var self = this;
            var jElement = $(self.element);
            
            jElement.removeClass(self.options.LoadingClass);
            var lOverlay = jElement.find('.' + self.options.OverlayClass);
            if (lOverlay.length != 0)
            {
                lOverlay.remove();
            }
        }
    });
})(jQuery);
